import { useState } from 'react';
import { useSearchParams } from 'react-router';
import { CenteredPage } from '../components/Shell';
import { LocaleSwitcher } from '../components/LocaleSwitcher';
import { useConnectivity, useT } from '../hooks';
import { useServices } from '../services';

/** Staff sign-in: hands over to the Keycloak login page (OIDC code + PKCE). */
export function LoginPage() {
  const t = useT();
  const { session } = useServices();
  const { browserOnline } = useConnectivity();
  const [params] = useSearchParams();
  const [pending, setPending] = useState(false);
  const [failed, setFailed] = useState(params.get('error') !== null);
  const signIn = async () => {
    setPending(true);
    setFailed(false);
    try {
      await session.signIn(params.get('to') ?? '/');
    } catch {
      setFailed(true);
      setPending(false);
    }
  };
  return (
    <CenteredPage logo>
      <div className="card__toolbar">
        <LocaleSwitcher />
      </div>
      <h1>{t('operator.login.title')}</h1>
      <p>{t('operator.login.subtitle')}</p>
      {failed && (
        <p role="alert" className="banner banner--error">
          {t('operator.login.failed')}
        </p>
      )}
      {!browserOnline && (
        <p role="status" className="banner banner--warning">
          {t('operator.login.needsConnection')}
        </p>
      )}
      <button
        type="button"
        className="button button--primary button--block button--large"
        disabled={pending || !browserOnline}
        aria-busy={pending}
        onClick={() => void signIn()}
      >
        {t('operator.login.signIn')}
      </button>
    </CenteredPage>
  );
}
